import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { Button, SIZE } from "baseui/button";
import { styled } from "baseui";
import { useHistory, useLocation } from "react-router-dom";
import SubHeader from "../../components/sub-header/SubHeader";
import ListSearchGroup from "../../components/list-search-group/ListSearchGroup";
import ListAsideView from "../../components/list-aside-view/ListAsideView";
import { TEMPLATES_SIDEBAR_ITEMS } from "../../constants/AppEnums";
import TemplateCreateNewView from "../template-create-new/TemplateCreateNewView";
import ListSidebarView from "../../components/list-sidebar/ListSidebarView";
import PaginatedSearchList from "../../components/paginated-search-list/PaginatedSearchList";
import Plus from "baseui/icon/plus";
import {
  cloneTemplate,
  fetchTemplates,
} from "../../redux/template/TemplateThunk";
import { setActiveTemplate } from "../../redux/template/TemplateActions";
import * as AppConstants from "../../constants/AppConstants";
import { useListSearchFilters } from "../../hooks/useListSearchFilters";
import ROUTES_PATH from "../../constants/RouteConstants";
import useToaster from "../../hooks/useToaster";
import { useFetchItemsList } from "../../hooks/useFetchItemsList";
import { Grid, Cell } from "baseui/layout-grid";
import CloneModal from "../../components/clone-modal/CloneModalComponent";
const MainContainer = styled(Grid, ({ $theme }) => ({
  margin: "auto auto",
  padding: AppConstants.APP_MAIN_PADDING,
  overflowY: "scroll",
}));

const SidebarArea = styled(Cell, ({ $theme }) => ({
  borderRight: "2px solid",
}));

function TemplateListView(props) {
  const history = useHistory();
  const [isNewSidebarOpen, setIsNewSidebarOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  // const [templates, setTemplates] = useState(props.templatesList);
  const [cloneTemplateId, setCloneTemplateId] = useState("");
  const [cloningInProgress, setCloningInProgress] = useState(false);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  const {
    viewMode,
    setViewMode,
    setFilterQuery,
    setSearchQuery,
    currentPage,
    setCurrentPage,
    numPages,
  } = useListSearchFilters("list", props.totalTemplates);
  useToaster(props.searchErrorMessage);
  useToaster(props.cloneErrorMessage);

  const { retryFetch } = useFetchItemsList(currentPage, fetchTemplates);

  useEffect(() => {
    setIsLoading(props.isLoadingSims);
  }, [props.isLoadingSims, props.searchError, props.searchErrorMessage]);

  // useEffect(() => {
  //   setTemplates(props.templatesList);
  // }, [props.templatesList]);

  useEffect(() => {
    if(props.clonedSuccess && !props.isCloneInProgress) {
      history.push(
        `${ROUTES_PATH.templateEditor}${props.activeTemplate.id}/${ROUTES_PATH.templateParameter}`
      );      
    } 
  }, [props.clonedSuccess, props.isCloneInProgress]);

  useEffect(() => {
    setCloningInProgress(props.isCloneInProgress);
    if (!props.isCloneInProgress) {
      setIsCreateModalOpen(false);
      // props.onFectchTemplatesByAccess(SIMULATOR_ACCESS_TYPES[location.hash]);
    }
  }, [props.isCloneInProgress]);
  function onModalCreateClick(newTitle, access) {
    props.onCloneTemplate(props.user, cloneTemplateId, newTitle, access);
  }

  function handleSelectTemplate(templateId) {
    props.handleSetActiveTemplate(templateId);
    history.push(
      `${ROUTES_PATH.templateEditor}${templateId}/${ROUTES_PATH.templateParameter}`
    );
  }
  return (
    <Fragment>
      <CloneModal
        onClose={() => setIsCreateModalOpen(false)}
        isOpen={isCreateModalOpen}
        headerTitle={"Clone Template"}
        onClone={(newTitle, access) => onModalCreateClick(newTitle, access)}
        cloningInProgress={cloningInProgress}
      />      

      <SubHeader
        centerChildren={
          <ListSearchGroup
            onTimeKeywordSearchChange={setSearchQuery}
            onRetryFetch={retryFetch}
            onViewModeChange={setViewMode}
          />
        }
      ></SubHeader>
      <MainContainer>
        <SidebarArea span={[1, 2, 2.5]}>
          <Button
            startEnhancer={<Plus size={24} />}
            $style={{
              width: "200px",
              borderRadius: "25px",
              margin: "15px 5px",
            }}
            onClick={() => {
              setIsNewSidebarOpen(true);
            }}
          >
            New Template{" "}
          </Button>
          <ListSidebarView items={TEMPLATES_SIDEBAR_ITEMS} />
        </SidebarArea>
        <Cell span={[2, 4, 7]}>
          <PaginatedSearchList
            isLoading={isLoading}
            retryFetch={retryFetch}
            error={props.searchError}
            errorMessage={props.searchErrorMessage}
            items={props.templatesList}
            viewMode={viewMode}
            onCreateItem={(templateId) => {
              setIsCreateModalOpen(true);
              setCloneTemplateId(templateId);
            }}
            onSelectItem={handleSelectTemplate}
            onPageChange={(page) => setCurrentPage(page)}
            currentPage={currentPage}
            numPages={numPages}
          />
        </Cell>
        <Cell span={[1, 2, 2.5]}>
          <ListAsideView
              onFilterSelectChange={setFilterQuery}

            >              
            </ListAsideView>
        </Cell>
      </MainContainer>
      <TemplateCreateNewView
        isOpen={isNewSidebarOpen}
        onClose={() => setIsNewSidebarOpen(false)}
      />
    </Fragment>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user.username,
    userId: state.user.userId,
    templatesList: state.template.templatesList,
    totalTemplates: state.template.total,
    isLoadingSims: state.template.isLoading,
    activeTemplate: state.template.activeTemplate,
    isCloneInProgress: state.template.isCloneInProgress,
    clonedSuccess: state.template.clonedSuccess,
    error: state.template.error,
    searchError: state.template.searchError,
    searchErrorMessage: state.template.searchErrorMessage,
    cloneErrorMessage: state.template.cloneErrorMessage,

  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFectchTemplates: (filter, from, size) => {
      dispatch(fetchTemplates(filter, from, size));
    },
    handleSetActiveTemplate: (templateId) => {
      dispatch(setActiveTemplate({ templateId }));
    },
    onCloneTemplate: (user, templateId, templateTitle, access) => {
      dispatch(cloneTemplate({ user, templateId, templateTitle, access }));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TemplateListView);
